export default __webpack_public_path__ + "static/media/anon_planet.14a894f9.jpg";